module.exports = __webpack_public_path__ + "img/pic-1.a9fb475e.png";